import { useToast } from './toast/index.js'

const HQ_SESSION = '__hqsession__'
const HQ_DEFAUL_CLIENT = '__hqclient__'

let sessionchecker

const toast = useToast()

let router = null
const setRouter = (newRouter) => router = newRouter

const storageManipulation = {
    resetSessionChecker() {
        clearInterval(sessionchecker)
        toast?.clear()

        // setup session checker
        // --> check every 60 seconds
        // --> warn 5 minutes, 2 minutes and 1 minute before
        // --> auto logout after session timeout
        let warnlevel = 0
        // TODO:
        const errormsg = 'Sie werden in einer Minute abgemeldet!' // this.$t('session.tobeloggedout')
        const warnmsg = 'Ihr Session läuft in 2 Minuten ab' // this.$t('session.warning')
        const infomsg = 'Ihr Session läuft in 5 Minuten ab' // this.$t('session.info')

        sessionchecker = setInterval(() => {
            const sessionexpiresin = storageManipulation.sessionExpiresIn()

            if (warnlevel === 2 && sessionexpiresin < 1 * 60 * 1000) {
                warnlevel = 3
                toast?.open({
                    message: errormsg,
                    type: 'error',
                    pauseOnHover: false,
                    position: 'bottom-right',
                    duration: 1 * 60 * 1000 // keep open for 1 minute, until logout
                })
            } else if (warnlevel === 1 && sessionexpiresin < 2 * 60 * 1000) {
                warnlevel = 2
                toast?.open({
                    message: warnmsg,
                    type: 'warning',
                    pauseOnHover: false,
                    position: 'bottom-right',
                    duration: 1 * 60 * 1000 // keep open for 1 minute, until next stage
                })
            } else if (warnlevel === 0 && sessionexpiresin < 5 * 60 * 1000) {
                warnlevel = 1
                toast?.open({
                    message: infomsg,
                    type: 'info',
                    pauseOnHover: false,
                    position: 'bottom-right',
                    duration: 3 * 60 * 1000 // keep open for 3 minutes, until next stage
                })
            } else if (storageManipulation.hasSessionExpired()) {
                router.push({ name: 'login' })
                storageManipulation.clearSessionData()
                warnlevel = 0
            }
        }, 1000 * 1)
    },
    setSessionData(creationtime, token, client, clientid, user, soapSessionId) {
        const sessionData = {
            created: creationtime,
            token: token,
            client: client,
            clientid: clientid,
            username: user,
            soapSessionId: soapSessionId
        }

        // save the client that was originally used
        if (!localStorage[HQ_SESSION]) {
            localStorage[HQ_DEFAUL_CLIENT] = client
        }

        localStorage[HQ_SESSION] = JSON.stringify(sessionData)

        storageManipulation.resetSessionChecker()
    },
    getDefaultClient() {
        return localStorage[HQ_DEFAUL_CLIENT]
    },
    resetDefaultClient() {
        localStorage.removeItem(HQ_DEFAUL_CLIENT)
    },
    getSessionData() {
        if (localStorage[HQ_SESSION]) {
            return JSON.parse(localStorage[HQ_SESSION])
        } else {
            return undefined
        }
    },
    hasSession() {
        return storageManipulation.getSessionData() ? true : false
    },
    getSessionToken() {
        return storageManipulation.getSessionData().token
    },
    clearSessionData() {
        localStorage.removeItem(HQ_SESSION)
        clearInterval(sessionchecker)
    },
    hasSessionExpired() {
        return storageManipulation.sessionExpiresIn() < 0
    },
    sessionExpiresIn() {
        const minutestotimeout = 30
        const mstotimeout      = minutestotimeout * 60 * 1000
        const currentdatetime  = new Date()
        const sessioncreated   = new Date(storageManipulation.getSessionData().created)
        const timeinsession = currentdatetime - sessioncreated
        return mstotimeout - timeinsession
    },
    extendSession() {
        // shouldn't matter, but just in case
        if (localStorage[HQ_SESSION]) {
            let currentSession = storageManipulation.getSessionData()
            currentSession.created = new Date().getTime()
            localStorage[HQ_SESSION] = JSON.stringify(currentSession)
            storageManipulation.resetSessionChecker()
        }
    }
}

const StorageManipulationPlugin = {
    install(app) {
        // compatibility for usage with "this.$function()"
        app.config.globalProperties.$setSessionData     = storageManipulation.setSessionData
        app.config.globalProperties.$getDefaultClient   = storageManipulation.getDefaultClient
        app.config.globalProperties.$resetDefaultClient = storageManipulation.resetDefaultClient
        app.config.globalProperties.$getSessionData     = storageManipulation.getSessionData
        app.config.globalProperties.$hasSession         = storageManipulation.hasSession
        app.config.globalProperties.$getSessionToken    = storageManipulation.getSessionToken
        app.config.globalProperties.$clearSessionData   = storageManipulation.clearSessionData
        app.config.globalProperties.$hasSessionExpired  = storageManipulation.hasSessionExpired
        app.config.globalProperties.$sessionExpiresIn   = storageManipulation.sessionExpiresIn
        app.config.globalProperties.$extendSession      = storageManipulation.extendSession
    }
}

const useStorageManipulation = () => storageManipulation

export default StorageManipulationPlugin

export { setRouter, useStorageManipulation }

